// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import AdminDataRow from 'components/common/AdminDataRow';
import AdminSection from 'components/common/AdminSection';
import BackButton from 'components/common/BackButton';
import Button from 'components/common/Button';
import CustomDashboardForm from 'components/forms/CustomDashboardForm';
// APOLLO
import customDashboardByIdQuery from 'ApolloClient/Queries/customDashboardById';
import saveCustomDashboard from 'ApolloClient/Mutations/saveCustomDashboard';
import deleteCustomDashboard from 'ApolloClient/Mutations/deleteCustomDashboard';
import { compose, graphql } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers/index';
// ANTD
import message from 'antd/lib/message';
// ANTD
import Popconfirm from 'antd/lib/popconfirm';
import 'antd/lib/popconfirm/style/css';

const CantFindDashboard = ({ onClick }) => {
    return (
      <PageContainer>
        We can not find this dashboard....{' '}
        <a href="#" onClick={onClick}>
          Go Back
        </a>
      </PageContainer>
    );
  };

  
class AdminDashboardDetail extends React.PureComponent {
  state  = {
    editing: false,
  }


  handleSaveDashboard = async params => {
    const dashboard = this.props.customDashboardByIdQuery.customDashboardById;
    let variables = {
      _id: dashboard._id,
      params,
    };

    try {
      await this.props.saveCustomDashboard({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('Dashboard successfully saved!');
    // window.location.reload();
  };

  onDeleteDashboard = async () => {
    const dashboard = this.props.customDashboardByIdQuery.customDashboardById;
    let variables = {
      _id: dashboard._id
    };

    try {
      await this.props.deleteCustomDashboard({ variables });
    } catch (err) {
      return ErrorHelpers.handleError(err);
    }

    message.success('Dashboard successfully saved!');
    window.location.reload();
  };

  
  render() {
    const dashboard = this.props.customDashboardByIdQuery.customDashboardById;
    // check to see if organization exists
    if (!dashboard) {
        return <CantFindDashboard onClick={this.props.history.goBack} />;
      }

    return (
      <div>
        <BackButton />
        <PageContainer>
          <React.Fragment>
            <AdminSection
              label={dashboard.name} 
              onEdit={() => this.setState({ editing: !this.state.editing })}
              onEditText={!this.state.editing ? 'edit' : 'cancel'}
            >
              {!this.state.editing ? (
                <React.Fragment>
                  <AdminDataRow label="ID">{dashboard._id}</AdminDataRow>
                  <AdminDataRow label="embedUrl">{dashboard.embedUrl}</AdminDataRow>
                  <AdminDataRow label="groupId">{dashboard.groupId}</AdminDataRow>
                  <AdminDataRow label="name">{dashboard.name}</AdminDataRow>
                  <AdminDataRow label="dashboardId">{dashboard.dashboardId}</AdminDataRow>
                  <AdminDataRow label="icon">
                    <img src={dashboard.icon} height="55" alt="dashboard-icon" /> {dashboard.icon}
                  </AdminDataRow>
                </React.Fragment>
              ): (
                <CustomDashboardForm
                  handleSubmit={this.handleSaveDashboard}
                  dashboard={dashboard}
                  buttonLabel="Save Changes"
                />
              )}
            </AdminSection>
            <AdminSection label="DANGER ZONE">
              <Popconfirm
                placement="topLeft"
                title="Are you sure?"
                onConfirm={this.onDeleteDashboard}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger">Delete Dashboard</Button>
              </Popconfirm>
            </AdminSection>
          </React.Fragment>
        </PageContainer>
      </div>
    );
  }
}

let options = props => ({
  variables: {
    _id: props.match.params.id,
  },
});

export default compose(
  graphql(customDashboardByIdQuery, { options, name: 'customDashboardByIdQuery' }),
  RecomposeHelpers.errorHOC({ propName: 'customDashboardByIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'customDashboardByIdQuery' }),
  graphql(saveCustomDashboard, { name: 'saveCustomDashboard' }),
  graphql(deleteCustomDashboard, { name: 'deleteCustomDashboard' }),
)(AdminDashboardDetail);



// WEBPACK FOOTER //
// ./src/routes/admin-dashboard-detail/index.js